import React, { useLayoutEffect } from 'react';
import { useParams } from 'umi';
import { PAGE_CONFIG } from './pageConfig';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { clearStudioFilterStorageByInstance } from '../utils/studioFilterStorage';
import './index.scss';

const CREATIVE_TRENDS_FILTER_INSTANCE_ID = 'studio-creative-trends';

const CreativeTrends = () => {
  const { gameCode, studioId } = useParams<{ gameCode?: string; studioId?: string; }>() || {};

  useLayoutEffect(() => {
    clearStudioFilterStorageByInstance(CREATIVE_TRENDS_FILTER_INSTANCE_ID);
    return () => {
      clearStudioFilterStorageByInstance(CREATIVE_TRENDS_FILTER_INSTANCE_ID);
    };
  }, []);

  return (
    <div className="dbh-studio-creative-trends-route">
      <CommonPageRender
        key={`${gameCode}-${studioId}`}
        reqParams="/creativeTrends"
        frameType="game"
        // @ts-ignore
        pageConfigInit={PAGE_CONFIG}
        api={PAGE_CONFIG_API}
      />
    </div>
  );
};

export default CreativeTrends;
